<div class="tour-card" id="feature-hint">
  <div class="tour-card-header d-flex align-items-center justify-content-between">
    <pcs-text-field [textFieldValue]="featureGuide.title"></pcs-text-field>
    <pcs-icon icon="close" (click)="complete()" size="iconM"></pcs-icon>
  </div>
  <div class="tour-card-body">
    <ng-template *ngTemplateOutlet="featureGuide.template"> </ng-template>
  </div>
  <div
    class="tour-card-footer d-flex flex-row-reverse align-items-center justify-content-between">
    <div class="d-flex align-items-center gap-1">
      <pcs-button
        *ngIf="hasPrevious()"
        buttonText="previous"
        buttonSize="small"
        (clicked)="previous()"></pcs-button>
      <pcs-button
        *ngIf="hasNext()"
        buttonText="general.action.next"
        buttonSize="small"
        (clicked)="next()"></pcs-button>
      <pcs-button
        *ngIf="!hasNext()"
        buttonStyle="primary"
        buttonText="general.message.confirm"
        buttonSize="small"
        (clicked)="complete()">
      </pcs-button>
    </div>
    <div class="d-flex align-items-center">
      <ng-container *ngIf="multiRegisteredFeatures()">
        <pcs-step
          *ngFor="let id of getFeaturesIds(); trackBy: trackByIndex"
          [active]="isActive(id)"></pcs-step>
      </ng-container>
    </div>
  </div>
</div>
